(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', '$state', 'Account', '$rootScope', '$analytics'];

    function Principal ($q, $state, Account, $rootScope, $analytics) {
        var _identity,
            _authenticated = false,
            currentIdentity;
        
        

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            currentIdentity: currentIdentity,
            findHasAnyAuthority: findHasAnyAuthority
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
            if (identity == null) {
            	$analytics.setUsername('');
            }
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }
        
        function findHasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return '';
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return authorities[i];
                }
            }

            return '';
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                service.currentIdentity = angular.copy(_identity);
                _authenticated = true;
                deferred.resolve(_identity);
                $rootScope.username = service.currentIdentity.login;
                $analytics.setUsername(service.currentIdentity.login);
                /*$state.go('home-main.home-page', {}, {
    				reload : true
    			});*/
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
